import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { keys } from '@/lib/queryKeys';
import { api } from '@/lib/api/client';
import type { PharmacyReport } from './types';

export function fetchPharmacyReport(from: string, to: string): Promise<PharmacyReport> {
  return api.get('/reports/pharmacy', { query: { from, to } });
}

/**
 * Branch-scoped — stock leaves one physical shelf and cash lands in one
 * physical till, so a group-level roll-up here would be a number no single
 * pharmacist could act on. The date range is part of the key rather than a
 * refetch parameter, so flipping back to a range already viewed is instant.
 */
export function usePharmacyReport(from: string, to: string) {
  const { branchVersion } = useAuth();
  return useQuery({
    queryKey: [...keys.reports.pharmacy(from, to), branchVersion],
    queryFn: () => fetchPharmacyReport(from, to),
    enabled: !!from && !!to,
  });
}
